

import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { store } from "./store/index";
import VueDayjs from "@/plugins/dayjs";




import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import { BVToastPlugin } from "bootstrap-vue";
import VueDatePicker from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";


// router setup
import router from "./routes/router";
import i18n from "./i18n";
import "./registerServiceWorker";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);



Vue.use(VueDayjs);
Vue.use(BVToastPlugin);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueDatePicker, {
  lang: "en",
});


Vue.use(RouterPrefetch);
Vue.use(VueSweetalert2);
Vue.directive("click-outside", {
  bind: function(el, binding) {
    // Define ourClickEventHandler
    const ourClickEventHandler = (event) => {
      if (!el.contains(event.target) && el !== event.target) {
        // as we are attaching an click event listern to the document (below)
        // ensure the events target is outside the element or a child of it
        binding.value(event); // before binding it
      }
    };
    // attached the handler to the element so we can remove it later easily
    el.__vueClickEventHandler__ = ourClickEventHandler;

    // attaching ourClickEventHandler to a listener on the document here
    document.addEventListener("click", ourClickEventHandler);
  },
  unbind: function(el) {
    // Remove Event Listener
    document.removeEventListener("click", el.__vueClickEventHandler__);
  },
});

/* eslint-disable no-new */
new Vue({
  store,
  el: "#app",
  render: (h) => h(App),
  router,
  
  i18n,
});
